import { render, staticRenderFns } from "./AddressStageProvider.vue?vue&type=template&id=1a855667&scoped=true&"
import script from "./AddressStageProvider.vue?vue&type=script&lang=js&"
export * from "./AddressStageProvider.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=1a855667&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a855667",
  null
  
)

export default component.exports